import contentBucket from '../../__tests__/React/uefa-tv/mocks/content-bucket';
import contentHome from '../../__tests__/React/uefa-tv/mocks/content-home';
import contentPlaylist from '../../__tests__/React/uefa-tv/mocks/content-playlist';

import { apiGet } from '@core/uefatvClient';
import type { Bucket, BaseContentItem, UefatvResponse, VOD, PlaylistItem } from '@shared-types/uefatv.types';
import { IS_SIMULATION } from '@utilities/browser';
import { uefaTvApiUrl } from '@utilities/WindowContext';

export const fetchSection = (
  { section, lastSeen = 'empty', bpp, rpp }: { section: string; lastSeen?: string; bpp?: string; rpp?: string },
  signal: AbortSignal,
) => {
  if (IS_SIMULATION) {
    return new Promise<Partial<UefatvResponse>>((resolve) => {
      setTimeout(() => {
        resolve({ ...contentHome, section, signal } as any);
      }, 500);
    });
  }
  const params = {
    ...(lastSeen !== 'empty' && { lastSeen }),
    rpp,
    bpp,
  };

  return apiGet<UefatvResponse>(`/v4/content/${section}`, uefaTvApiUrl, params, signal);
};

export const fetchVideoById = (vodId: string, signal: AbortSignal) =>
  apiGet<BaseContentItem>(`/v4/vod/${vodId}`, uefaTvApiUrl, null, signal);

export const fetchPlaylistById = (
  { id, lastSeen = 'empty', bpp, rpp }: { id: string; lastSeen?: string; bpp?: string; rpp?: string },
  signal: AbortSignal,
) => {
  if (IS_SIMULATION) {
    return new Promise<Partial<PlaylistItem>>((resolve) => {
      setTimeout(() => {
        resolve({ ...contentPlaylist, id, signal } as any);
      }, 500);
    });
  }

  const params = {
    ...(lastSeen !== 'empty' && { lastSeen }),
    rpp,
    bpp,
  };

  return apiGet<PlaylistItem>(`/v4/playlist/${id}`, uefaTvApiUrl, params, signal);
};

export const fetchStreamById = (vodId: number, signal: AbortSignal) =>
  apiGet<VOD>(`/v4/stream/vod/${vodId}`, uefaTvApiUrl, null, signal);

export const fetchBucketById = (
  { bucketId, lastSeen = 'empty', bpp, rpp }: { bucketId: string; lastSeen?: string; bpp?: string; rpp?: string },
  signal: AbortSignal,
) => {
  if (IS_SIMULATION) {
    return new Promise<Partial<Bucket>>((resolve) => {
      setTimeout(() => {
        resolve({ ...contentBucket, bucketId, signal } as any);
      }, 500);
    });
  }

  const params = {
    ...(lastSeen !== 'empty' && { lastSeen }),
    rpp,
    bpp,
  };

  return apiGet<Bucket>(`/v4/content/bucket/${bucketId}`, uefaTvApiUrl, params, signal);
};
